// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.tabs_show_class[data-v-8b43e4d2] .el-tabs__item.is-top {\n  font-size: 17px !important;\n  font-weight: 545 !important;\n}\n.tabs_show_class[data-v-8b43e4d2] .el-tabs__active-bar.is-top {\n  background-color: red !important;\n  height: 5px !important;\n}\n.el-table[data-v-8b43e4d2] .sort-caret.ascending {\n  display: none;\n}\n.el-table[data-v-8b43e4d2] .sort-caret.descending {\n  bottom: 10px;\n}\n.switch-tag-class[data-v-8b43e4d2] {\n  display: flex;\n  font-size: 15px;\n  width: 40px;\n  height: 90%;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  border-radius: 10px;\n}\n.el-button--goon-focus[data-v-8b43e4d2], .el-button--goon[data-v-8b43e4d2]:hover {\n  color: #FF0000 !important;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabs_show_class": "tabs_show_class",
	"el-tabs__item": "el-tabs__item",
	"is-top": "is-top",
	"el-tabs__active-bar": "el-tabs__active-bar",
	"el-table": "el-table",
	"sort-caret": "sort-caret",
	"ascending": "ascending",
	"descending": "descending",
	"switch-tag-class": "switch-tag-class",
	"el-button--goon-focus": "el-button--goon-focus",
	"el-button--goon": "el-button--goon"
};
module.exports = ___CSS_LOADER_EXPORT___;
